import React from 'react';

import CreateDocument from 'App/Homeowner/Documents/CreateDocument';
import ListDocuments from 'App/Homeowner/Documents/ListDocuments';
import paths from 'config/local/paths';
import Page from 'shared/Page';
import Switch from 'shared/Switch';
import { translate } from 'App/Internationalization';
import { withActivityService } from '../../../service-container';

const InjectedListDocuments = withActivityService(ListDocuments);

export default class Documents extends React.Component {
	render() {
		const propertyId = this.props.match?.params?.propertyId;
		const documentsRootPath = propertyId
			? paths.app.homeowner.properties.scoped.documents.replace(
					':propertyId',
					propertyId
			  )
			: paths.app.homeowner.documents.root;
		const documentsCreatePath = propertyId
			? `${documentsRootPath}/upload`
			: paths.app.homeowner.documents.create;

		return (
			<Switch>
				<Page
					component={InjectedListDocuments}
					exact={true}
					path={documentsRootPath}
					title={translate('homeowner.nav.documents.root')}
				/>
				<Page
					component={CreateDocument}
					path={`${documentsCreatePath}/:category`}
					title={translate('homeowner.nav.documents.create')}
				/>
			</Switch>
		);
	}
}
